<template>
  <el-dialog :title="title" :visible.sync="Dialog" width="80%" center :close-on-click-modal="false" @close="closeDialog">
    <el-form label-position="top" ref="sendItemData" :model="sendItemData" label-width="80px">
      <el-form-item label="教授邮箱">
        <el-input type="text" disabled v-model="sendItemData.email" />
      </el-form-item>
      <el-form-item label="邮箱内容">
        <quill-editor v-model="sendItemData.email_content" :options="editorOptions"></quill-editor>
      </el-form-item>
      <el-form-item label="邮箱附件">
        <el-table ref="multipleTable" :data="document_list" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column label="类型" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 'cv'">CV文书</span>
              <span v-if="scope.row.type == 'paper'">论文</span>
              <span v-if="scope.row.type == 'rp'">RP文书</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" >
            <template slot-scope="scope">
              <el-link type="primary" @click="()=>{previewUrl=scope.row.url;previewName=scope.row.name}">{{scope.row.name}}</el-link>
            </template>
          </el-table-column>
        </el-table>


      </el-form-item>
      <div style="margin: 10px;text-align: center">
        <el-button @click="closeDialog">返回</el-button>
<!--        <el-button type="primary" v-loading="loading" :disabled="loading" @click="onSubmit">保存模板</el-button>-->
      </div>
    </el-form>
    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null" />
  </el-dialog>
</template>
<script>

import { get_email_annex_list, save_email_template } from '@/api/mycenter_studyabroad.js'
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';
export default {
  components: {
    quillEditor,
    HBFilePreview
  },
  name: 'HBDoctorMagnetsEmailDialog',
  data() {
    return {
      previewUrl: '',
      previewName: '',
      loading: false,
      sendItemData: {
        id: '',
        type: '',
        email: '',
        email_content: '',
        email_template_status: ''
      },
      Dialog: false,
      title: '邮箱模板',
      content: '',
      document_list: [],
      // document_cv: '',
      // document_rp: '',
      // document_tc: '',
      // document_tcs: '',
      editorOptions: {
        // Quill options
        height: '600px',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        },
        theme: 'snow'
      }
    }
  },
  created() {

  },
  methods: {
    handleSelectionChange(val) {
      this.multipleTable = val
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.toggleRowSelection(rows)
      console.log('this.multipleTable',this.multipleTable)
    },
    sendItem(_content,_type) {
      this.sendItemData = _content
      this.sendItemData.type = _type
      this.sendItemData.email_template_status = _content.email_template_status
      this.get_email_annex_list(this.sendItemData.id);
      this.Dialog = true
    },
    get_email_annex_list(_id) {
      get_email_annex_list({ user_id: this.$route.query.userId, id: _id }).then((response) => {
        this.document_list = response.data
        this.$nextTick(() => {
          response.data.forEach((item) => {
            if (item.status == 2) {
              this.toggleSelection(item)
            }
          })
        })
      })
    },
    closeDialog() {
      this.document_list = []
      this.Dialog = false
    },
    // onSubmit() {
    //   if (this.sendItemData.email_content.length === 0) {
    //     this.$message.error('邮箱内容不能为空')
    //     return
    //   }
    //   if (this.sendItemData.email_template_status != 3 && this.sendItemData.email_template_status != 4 ) {
    //     this.$message.error('邮箱类型不能为空')
    //     return
    //   }
    //   this.sendItemData.user_id = this.$route.query.userId
    //   this.loading = true
    //   save_email_template(this.sendItemData).then((response) => {
    //     this.loading = false
    //     this.$message.success('保存成功')
    //     this.$emit('get_list')
    //     this.closeDialog()
    //   }).catch((error) => {
    //     this.loading = false
    //     console.log(error)
    //   })
    // },

  }
}
</script>
<style>
.quill-editor-container {
  min-height: 300px;
  max-height: 600px;
  overflow: auto;
}
.ql-editor{
  min-height: 500px !important;
  max-height: 800px !important;
  overflow: auto !important;
}
.quill-editor{
  min-height: 300px;
  max-height: 600px;
  overflow: auto;
}
@media (max-width: 768px) {
  .quill-editor-container {
    min-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/HBCommon/HBEmailDialog/HBEmailDialog.vue